<template>
  <v-container elevation="0" fluid style="margin: 0">
    <v-snackbar v-model="showError" top right color="#FCE1D8">
      <global-msg-alert
        v-if="showErrorTryRevokeRevokedItems"
        iconColor="#9D0E1C"
        iconSize="2.5rem"
        icon="fa-circle-exclamation"
        textColor="color: #9D0E1C"
        type="Error"
        msg="Marked items are already revoked"
      ></global-msg-alert>
      <global-msg-alert
        v-if="showErrorTryReinstateReinstatedItems"
        iconColor="#9D0E1C"
        iconSize="2.5rem"
        icon="fa-circle-exclamation"
        textColor="color: #9D0E1C"
        type="Error"
        msg="Marked items are active or revocation reason is not OnHold"
      ></global-msg-alert>
    </v-snackbar>
    <v-row class="pa-3 justify-space-between">
      <div>
        <div class="toolbar-div">
          <v-select
            item-color="#006CA1"
            dense
            color="#006CA1"
            class="py-1 column-select"
            background-color="white"
            v-model="columnsModel"
            :items="columnsItems"
            label="Select columns"
            multiple
            hide-details
            outlined
            :menu-props="{ bottom: true, offsetY: true }"
          >
            <template v-slot:selection="{ attrs, item, select, selected, index }">
              <v-chip
                small
                v-if="index < 2"
                v-bind="attrs"
                color="#EFF2FE"
                close
                label
                @click:close="remove(item)"
              >
                {{ item }}
              </v-chip>
              <span v-if="index === 1 && columnsModel.length > 2" class="grey--text text-caption ml-2">
                (+{{ columnsModel.length - 2}})
              </span>
            </template>
          </v-select>
        </div>
      </div>
      <div class="align-center my-auto">
        <v-menu offset-y>
          <template v-slot:activator="{ attrs, on }">
            <transition name="bounce" mode="out-in">
              <v-btn
                key="1"
                small
                color="#006CA1"
                depressed
                class="white--text"
                v-bind="attrs"
                v-on="on"
                id="custom-disabled"
                @click="batchToggle = !batchToggle"
                :disabled="selectedCertsLength <= 0"
              >
                <v-icon x-small class="mr-2" id="custom-disabled">fa-bars</v-icon>
                Batch actions
                <v-chip class="ml-2" x-small color="white">{{
                  selectedCertsLength
                }}</v-chip>
                <v-icon class="ml-2" small v-if="!batchToggle">fa-chevron-down</v-icon>
                <v-icon class="ml-2" small v-if="batchToggle">fa-chevron-up</v-icon>
              </v-btn>
            </transition>
          </template>
          <v-list>
            <v-list-item v-if="canBatchBeRevoked()" dense @click="revokeButton">
              <v-icon medium class="mr-1">fa-light fa-ban</v-icon>Revoke
            </v-list-item>
            <v-list-item v-if="canBatchBeReinstated()" dense @click="reinstateButton">
              <v-icon medium class="mr-1">fa-light fa-circle-check</v-icon>Reinstate
            </v-list-item>
            <v-menu right offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-if="canBatchBeDownloaded()" v-bind="attrs" v-on="on" dense>
                  <i class="pr-1 fa-regular fa-download fa-xl"></i>
                  Download
                </v-list-item>
              </template>
              <v-list>
                <v-list-item
                  v-for="(format, index) in constants.CERTIFICATE_FORMATS"
                  :key="index"
                  @click="downloadBatch(format.type, format.extension)"
                >
                  <v-list-item-title>
                    {{ format.type }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list>
        </v-menu>
      </div>
    </v-row>
    <v-row class="text-subtitle-2 px-3 justify-space-between"
      ><div>
        <span v-if="selectedCertsLength === 0">
          0 rows selected
        </span>
        <span style="color: #c56430" v-if="selectedCertsLength > 0">
          {{ selectedCertsLength }} rows selected: certificates of type
        </span>
        <span v-if="selectedCertsLength > 0" v-for="label in this.getSelectedSubjectTypeLabels()">
          {{label.text}}{{label.last ? "" : ", "}}
        </span>
        <span v-if="selectedCertsLength > 0" style="color: #c56430">
          with status
        </span>
        <span v-if="selectedCertsLength > 0" v-for="label in getSelectedStatusLabels()">
          <span :style="`color: ${label.color}`">{{ label.text }}{{label.last ? "" : ", "}}</span>
        </span>
      </div>
      <div
        v-if="this.getNotSupportedBatchOperationLabels().length > 0"
      >
        <i class="fa-light fa-circle-info"></i>
        <span style="color: #006ca1">
          Batch actions not supported for current selection:
          <span v-for="label in this.getNotSupportedBatchOperationLabels()">
            {{label.text}}{{label.last ? "" : ", "}}
          </span>
        </span>
      </div>
      <div>
       <span style="color: #006ca1">
         Found items: {{ itemsFound }}
       </span>
      </div>
      </v-row
    >
  </v-container>
</template>

<script>
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import pgwyClient from "@/api/pgwyClient";
import {canBeDownloaded, canBeReinstated, canBeRevoked} from "@/Mixins/certificates/getActionsMixin";
import {getStatusLabel, getStatusColor} from "@/Mixins/certificates/getStatusMixin"
import * as constants from "@/config/constants";
import {CERTIFICATE_HEADERS} from "@/config/certificate-headers";

export default {
  props: [
    "selectedCertsLength",
    "itemsFound",
    "showErrorTryRevokeRevokedItems",
    "showErrorTryReinstateReinstatedItems",
    "selectedCerts",
    "format"
  ],
  mixins: [getStatusLabel, getStatusColor, canBeDownloaded, canBeRevoked, canBeReinstated],
  components: { GlobalMsgAlert },
  created() {
  },
  data() {
    return {
      batchToggle: false,
      isCA: false,
      revokeButtonLoader: false,
      reinstateButtonLoader: false,
      columnsModel: CERTIFICATE_HEADERS
          .filter((header) => header.defaultVisible && !header.required)
          .map((header) => header.shortText),
      columnsItems: CERTIFICATE_HEADERS
          .filter((header) => !header.required)
          .map((header) => header.shortText),
      showError: false,
    };
  },
  computed: {
    constants() {
      return constants;
    },
  },
  watch: {
    columnsModel(columnsModel) {
      // localStorage.setItem("localColumnsModel", JSON.stringify(columnsModel));
      this.$emit("columnsChanged", columnsModel);
    },
    showErrorTryRevokeRevokedItems(ss, d) {
      this.showError = true;
    },
    showErrorTryReinstateReinstatedItems() {
      this.showError = true;
    },
  },
  methods: {
    getNotSupportedBatchOperationLabels() {
      const ops = [];
      if (!this.canBatchBeDownloaded()) {
        ops.push("Download");
      }
      if (!this.canBatchBeRevoked()) {
        ops.push(this.hasCACertificate() ? "Revoke (not allowed for CA subject type)" : "Revoke")
      }
      if (!this.canBatchBeReinstated()) {
        ops.push("Reinstate");
      }
      return this.getLabels(ops, (op) => op);
    },
    hasCACertificate() {
      return this.selectedCerts.some((cert) => cert.subjectType === "CA");
    },
    canBatchBeDownloaded() {
      return this.selectedCerts.every((cert) => this.canBeDownloaded(cert));
    },
    canBatchBeRevoked() {
      return this.selectedCerts.every((cert) => this.canBeRevoked(cert));
    },
    canBatchBeReinstated() {
      return this.selectedCerts.every((cert) => this.canBeReinstated(cert));
    },
    getLabels(items, textFn, colorFn = () => "") {
      let labels = [];
      items.forEach((cert) => {
        const text = textFn(cert);
        if (!labels.some((label) => label.text === text)) {
          labels.push({
            text,
            color: colorFn(cert)
          });
        }
      });
      if (labels.length > 0) {
        labels[labels.length - 1].last = true;
      }
      return labels;
    },
    getSelectedSubjectTypeLabels() {
      return this.getLabels(this.selectedCerts, (cert) => cert.subjectType);
    },
    getSelectedStatusLabels() {
      return this.getLabels(this.selectedCerts,
          (cert) => this.getStatusLabel(cert),
          (cert) => this.getStatusColor(cert));
    },
    async downloadBatch(type, extension) {
      await pgwyClient.downloadCertificates(this.selectedCerts.map((cert) => cert.certid), type, extension);
    },
    revokeItemsClicked(revokeReason) {
      constants.REVOCATION_REASONS.forEach((reason) => {
        if (revokeReason === reason.id) {
          this.$emit("revokeItemsClicked", reason.id);
        }
      });
    },
    reinstateItemsClicked() {
      this.$emit("reinstateItemsClicked");
    },
    remove(item) {
      this.columnsModel.splice(this.columnsModel.indexOf(item), 1);
    },
    revokeButton() {
      this.$emit("revokeButton", this.selectedCerts);
    },
    reinstateButton() {
      this.$emit("reinstateButton", this.selectedCerts);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

::v-deep .v-list-item--link::before {
  background-color: #006ca1;
}

::v-deep .theme--light.v-list-item:hover::before {
  opacity: 0.4;
}
.bounce-enter-active {
  animation: bounce-in 0.3s ease-out;
}
.bounce-leave-active {
  animation: bounce-out 0.3s ease-out;
}
@keyframes bounce-in {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes bounce-out {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
.dont-break {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 400px !important;
  cursor: pointer;
}
::v-deep .v-chip__content {
  color: #006ca1;
}
#custom-disabled.v-icon {
  color: #e8eaf6 !important;
}
#custom-disabled.v-btn--disabled {
  opacity: 0.5;
  background-color: #006CA1 !important;
  color: #e8eaf6 !important;
}
::v-deep .v-select__slot {
  min-width: 10rem;
}
::v-deep .v-select__slot input {
  display: none;
}
</style>
